module.exports = __webpack_public_path__ + "static/media/stripe.fa712572.svg";